import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { CallState } from '@lcs/shared/api';
import { Subject } from 'rxjs';
import { UsStates } from 'src/app/common-components/confirmation-dialog/enumerations/states';
import { countryDisplayWith, countrySearch, getCountries } from 'src/app/common-components/helpers/country-helper';

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: 'ndt-add-account-location-view',
    templateUrl: './add-account-location-view.component.html',
    standalone: false
})
export class AddAccountLocationViewComponent implements OnDestroy, OnInit {
   @Output() formSubmitted = new EventEmitter<any>();

   @Output() formCanceled = new EventEmitter<void>();

   @Input() callState: CallState;

   @Input() form: UntypedFormGroup;

   @Input() isEdit: boolean;

   destroyed$ = new Subject<void>();

   locationRequired = true;

   countries = getCountries();

   states = UsStates.states;

   countrySearch = countrySearch;

   countrySearchReset = getCountries;

   countryDisplayWith = countryDisplayWith;

   ngOnInit(): void {}

   ngOnDestroy(): void {
      this.destroyed$.next();
   }

   onCloseClick(): void {
      this.formCanceled.emit();
   }

   onCreate(continuous = false): void {
      if (this.form.valid) {
         const formValue = this.form.value;

         this.formSubmitted.emit({
            location: formValue,
            continuous,
         });

         if (continuous) {
            this.form.reset({
               name: null,
               houseNumber: null,
               directionalPrefix: null,
               streetName: null,
               streetNameSuffix: null,
               directionalPostfix: null,
               timeZone: null,
               city: null,
               state: null,
               postalCode: null,
               country: null,
               comment: null,
            });

            Object.keys(this.form.controls).forEach((key) => {
               const control = this.form.get(key);
               if (control) {
                  control.markAsUntouched();
                  control.markAsPristine();
               }
            });

            this.form.markAsPristine();
         }
      } else {
         this.form.markAllAsTouched();
      }
   }

   handleStateChange(isDirty: boolean): void {
      if (isDirty) {
         this.form.controls['state'].markAsDirty();
         this.form.controls['state'].updateValueAndValidity();
      }
   }

   stateDisplayWith(option: { abbreviation: string; name: string }): string {
      return `${option ?? ''}`;
   }

   stateSearch(searchText: string) {
      this.states = UsStates.states.filter(
         (state) =>
            state.name.toUpperCase().includes(searchText.toUpperCase()) ||
            state.abbreviation.toUpperCase().includes(searchText.toUpperCase())
      );
   }

   stateSearchReset() {
      this.states = UsStates.states;
   }
}
